module.exports = __webpack_public_path__ + "img/noPhoto.98f2bd81.png";